export default __webpack_public_path__ + "static/913-79d3894813b878dd9c9fce583c4f3bfa.gif";